import { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import AppContext from '@/common/context/app.context'

import routes from '../routes.constants'

const RedirectToUnifiedDashboard = () => {
  const navigation = useNavigate()
  const location = useLocation()
  const { info } = useContext(AppContext)

  useEffect(() => {
    if (info?.allows_unified_dashboard) {
      setTimeout(() => {
        if (!sessionStorage.getItem('hasAlreadyNavigated') && location.pathname === '/') {
          navigation(routes.merchantDashboardPage, { replace: true })
        }
        sessionStorage.setItem('hasAlreadyNavigated', 'true')
      }, 0)
    }
  }, [info?.allows_unified_dashboard, location.pathname, navigation])
}

export default RedirectToUnifiedDashboard
